import React from 'react'
import { createPortal } from 'react-dom'
import { SubmitHandler, useForm } from 'react-hook-form'

import { graphql, useStaticQuery } from 'gatsby'

import { wpMediaItemType } from '@contracts/wp/wpMedia'

import * as buttonStyles from '../Button/Button.module.scss'
import Image from '../WordPress/Image'
import Wysiwyg from '../Wysiwyg/Wysiwyg'
import * as styles from './NewsletterPopup.module.scss'

type Data = {
	wp: {
		themeSettings: {
			themeSettings: {
				newsletterPopupContent: {
					title: string
					subtitle: string
					text: string
					image: wpMediaItemType
				}
			}
		}
	}
}

type Inputs = {
	'cm-name': string
	'cm-xujtri-xujtri': string
}

const NewsletterPopup: React.FC = () => {
	const [isBrowser, setIsBrowser] = React.useState(false)
	const [close, setClose] = React.useState(false)

	const [loading, setLoading] = React.useState(false)
	const [wasSuccessful, setWasSuccessful] = React.useState(false)
	const [wasUnsuccessful, setWasUnsuccessful] = React.useState(false)

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<Inputs>()

	const data = useStaticQuery<Data>(graphql`
		query NewsletterPopupContent {
			wp {
				themeSettings {
					themeSettings {
						newsletterPopupContent {
							title
							subtitle
							text
							image {
								...wpMediaItem
								localFile {
									childImageSharp {
										gatsbyImageData(width: 550, aspectRatio: 1.0, quality: 90)
									}
								}
							}
						}
					}
				}
			}
		}
	`)

	React.useEffect(() => {
		if (window) {
			setIsBrowser(true)
		}
	}, [])

	const onSubmit: SubmitHandler<Inputs> = async (data) => {
		setLoading(true)
		setWasSuccessful(false)
		setWasUnsuccessful(false)

		try {
			const response = await fetch('https://tankpr.createsend.com/t/j/s/xujtri/', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			})

			if (response.status === 200) {
				setWasSuccessful(true)
			} else {
				setWasUnsuccessful(true)
			}
		} catch (error) {
			setWasUnsuccessful(true)
		}

		setLoading(false)
	}

	if (!isBrowser || close) return null

	const { newsletterPopupContent } = data.wp.themeSettings.themeSettings

	return createPortal(
		<div className={styles.newsletterPopup}>
			<div className={styles.content}>
				<div className={styles.left}>
					<Wysiwyg data={newsletterPopupContent.title} className={styles.title} />

					<Wysiwyg data={newsletterPopupContent.subtitle} className={styles.subtitle} />

					<Wysiwyg data={newsletterPopupContent.text} className={styles.text} />

					<form onSubmit={handleSubmit(onSubmit)}>
						<label htmlFor="newsletter-popup-email">
							<p>Enter your email</p>
							<input
								type="email"
								{...register('cm-xujtri-xujtri', { required: true, pattern: /^\S+@\S+$/i })}
							/>

							{errors['cm-xujtri-xujtri'] && (
								<span className={styles.error}>
									{errors['cm-xujtri-xujtri'].type == 'required' && 'Email is required'}
									{errors['cm-xujtri-xujtri'].type == 'pattern' && 'Email is not valid'}
								</span>
							)}
						</label>

						<button type="submit" className={buttonStyles.button}>
							Subscribe
						</button>

						<span>You can unsubscribe at any time.</span>
					</form>
				</div>

				<div className={styles.right}>
					<Image image={newsletterPopupContent.image} altText="" />
				</div>

				<div className={styles.close} onClick={() => setClose(true)}>
					<span>X</span>
				</div>
			</div>
			<div className={styles.background}></div>
		</div>,
		document.getElementById('newsletter-popup') as HTMLElement
	)
}

export default NewsletterPopup
